// extracted by mini-css-extract-plugin
export default {"App":"login_App__bh2SI","formContainer":"login_formContainer__NevnO","directionButton":"login_directionButton__Wss9W","directionButton2":"login_directionButton2__hVpY1"};